import {comRequest} from "@/Fwk/Http/comRequest";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import type {API_ACCOUNT} from "@/app/_api/types/account";
import RequestMgr, {NetType} from "@/Fwk/Http/RequestMgr";

export async function gameLevelList(params = {}): Promise<API_ACCOUNT.GameLevelListResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.GameLevels),
        method: 'POST',
        body: params,
        // headers: {
        //     'Authorization': LoginNetManager.Instance.getLoginToken
        // },
    };
    const response = await DoSendRequest<API_ACCOUNT.GameLevelListResponse>(config);
    return response.data;
}

export async function vipConfigList(params = {}): Promise<API_ACCOUNT.VipConfigListResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.VipConfigs),
        method: 'POST',
        body: params,
        // headers: {
        //     'Authorization': LoginNetManager.Instance.getLoginToken
        // },
    };
    const response = await DoSendRequest<API_ACCOUNT.VipConfigListResponse>(config);
    return response.data;
}

export async function userSignOut(params = {}): Promise<Boolean> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.Logout),
        method: 'POST',
        body: params,
    };
    const response = await comRequest<Boolean>(config);
    return response.data;
}

export async function updateUser(params: {userId: number, nickname: string}): Promise<API_ACCOUNT.UpdateUserResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.UpdateUser),
        method: 'POST',
        body: params,
    };
    const response = await DoSendRequest<API_ACCOUNT.UpdateUserResponse>(config);
    return response.data;
}

export async function DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
    config.isSerErrTips = true;
    const sendRequest = await comRequest<T>(config);
    return sendRequest;
}
